import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const MyPlaylists = lazy(() => import("@kaltura/mediaspace-features-my-playlists"));
export const render = getDsLayoutComponentRenderer(MyPlaylists);

export { CreatePlaylist } from "@kaltura/mediaspace-features-my-playlists/content-container/create-playlist";
export { DeletePlaylistMenuItem } from "@kaltura/mediaspace-features-my-playlists/content-container/search-results-section/search-results/cards-container/card/actions/DeletePlaylistMenuItem";
